import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';

export const productMethods = {
  ...mapActions('admin/products', [
    'getProducts',
    'storeProduct',
    'getProduct',
    'updateProduct',
    'updateProductCover',
    'updateProductBrochure',
    'publishProduct',
    'unpublishProduct',
    'deleteProduct',
  ]),
  ...mapMutations('admin/products', ['setIds', 'setMeta', 'setLinks', 'setCurrent']),
};

export const productComputed = {
  ...mapState('admin/products', ['meta', 'links']),
  ...mapGetters('admin/products', ['products', 'product', 'productById', 'categories']),
};

export const packageItemMethods = {
  ...mapActions('admin/packageItems', [
    'getPackageItems',
    'storePackageItem',
    'updatePackageItem',
    'deletePackageItem',
  ]),
  ...mapActions('admin/products', ['getProducts']),
  ...mapMutations('admin/packageItems', ['setIds', 'setMeta', 'setLinks', 'setCurrent']),
};

export const packageItemComputed = {
  ...mapGetters('admin/packageItems', ['packageItems', 'packageItem']),
  ...mapGetters('admin/products', ['products']),
};

export const packageEditionMethods = {
  ...mapActions('admin/packageEditions', [
    'getPackageEditions',
    'storePackageEdition',
    'updatePackageEdition',
    'deletePackageEdition',
  ]),
  ...mapMutations('admin/packageEditions', [
    'setIds',
    'setMeta',
    'setLinks',
    'setCurrent',
    'setWipProp',
    'setWip',
    'clearWip',
  ]),
};

export const packageEditionComputed = {
  ...mapState('admin/packageEditions', ['ids', 'meta', 'links', 'wip']),
  ...mapGetters('admin/packageEditions', ['packageEditions', 'packageEdition']),
  ...mapGetters('admin/packageItems', ['packageItems']),
};

export const roleMethods = {
  ...mapActions('admin/roles', ['getRoles', 'storeRole', 'getRole']),
  ...mapMutations('admin/roles', ['setIds', 'setMeta', 'setLinks', 'setCurrent']),
};

export const roleComputed = {
  ...mapState('admin/roles', ['meta', 'links']),
  ...mapGetters('admin/roles', ['roles', 'role']),
};

export const rolePermissionMethods = {
  ...mapActions('admin/rolePermissions', ['editPermissions', 'updatePermissions']),
  ...mapMutations('admin/rolePermissions', ['setIds', 'setMeta', 'setLinks', 'setCurrent']),
};

export const rolePermissionComputed = {
  ...mapState('admin/rolePermissions', ['ids', 'meta', 'links']),
  ...mapGetters('admin/rolePermissions', ['permissions']),
};

export const facebookCampaignMethods = {
  ...mapActions('admin/facebookCampaigns', ['getFacebookCampaigns', 'getFacebookCampaign']),
  ...mapMutations('admin/facebookCampaigns', ['setIds', 'setMeta', 'setLinks', 'setCurrent']),
};

export const facebookCampaignComputed = {
  ...mapState('admin/facebookCampaigns', ['ids', 'meta', 'links']),
  ...mapGetters('admin/facebookCampaigns', ['facebookCampaigns', 'facebookCampaign']),
};

export const facebookCampaignAdsetMethods = {
  ...mapActions('admin/facebookCampaignAdsets', ['getFacebookCampaignAdsets']),
  ...mapMutations('admin/facebookCampaignAdsets', ['setIds', 'setMeta', 'setLinks', 'setCurrent']),
};

export const facebookCampaignAdsetComputed = {
  ...mapState('admin/facebookCampaignAdsets', ['ids', 'meta', 'links']),
  ...mapGetters('admin/facebookCampaignAdsets', ['adsets']),
};

export const facebookCampaignAdMethods = {
  ...mapActions('admin/facebookCampaignAds', ['getFacebookCampaignAds']),
  ...mapMutations('admin/facebookCampaignAds', ['setIds', 'setMeta', 'setLinks', 'setCurrent']),
};

export const facebookCampaignAdComputed = {
  ...mapState('admin/facebookCampaignAds', ['ids', 'meta', 'links']),
  ...mapGetters('admin/facebookCampaignAds', ['ads']),
};

export const facebookCampaignChannelMethods = {
  ...mapActions('admin/facebookCampaignChannel', [
    'storeFacebookCampaignChannel',
    'getFacebookCampaignChannel',
    'updateFacebookCampaignChannel',
  ]),
  ...mapMutations('admin/facebookCampaignChannel', ['setIds', 'setMeta', 'setLinks', 'setCurrent']),
};

export const facebookCampaignChannelComputed = {
  ...mapState('admin/facebookCampaignChannel', ['current', 'ids', 'meta', 'links']),
  ...mapGetters('admin/facebookCampaignChannel', ['channel', 'facebookCampaign']),
};

export const channelMethods = {
  ...mapActions('admin/channels', ['storeChannel', 'editChannel', 'updateChannel']),
  ...mapMutations('admin/channels', ['setIds', 'setMeta', 'setLinks', 'setCurrent']),
};

export const channelComputed = {
  ...mapState('admin/channels', ['ids', 'meta', 'links']),
  ...mapGetters('admin/channels', ['channel']),
};

export const userMethods = {
  ...mapActions('admin/users', ['getUsers', 'getUser', 'editUser', 'updateUser']),
  ...mapMutations('admin/users', [
    'setIds',
    'setMeta',
    'setLinks',
    'setCurrent',
    'setWipUserId',
    'setWipIncludedRoleIds',
  ]),
};

export const userComputed = {
  ...mapState('admin/users', ['ids', 'meta', 'links', 'wip']),
  ...mapGetters('admin/users', ['users', 'user', 'wipUser', 'wipIncluded']),
};
